import { Observable, Subject } from 'rxjs';
import { prepare } from '@aid/shared/operators/prepare';
import { finalize } from 'rxjs/operators';

export function indicate<T>(
  indicator: Subject<boolean>
): (source: Observable<T>) => Observable<T> {
  return (source: Observable<T>): Observable<T> =>
    source.pipe(
      prepare(() => indicator.next(true)),
      finalize(() => indicator.next(false))
    );
}
